var base = require('settings/teams/mailed-invitations');

Vue.component('spark-mailed-invitations', {
    mixins: [base],

    data() {
        return {
            form: new SparkForm({
                email: ''
            })
        };
    },

    methods: {
        resendInvitation(invitation) {
            // console.log('[ resendInvitation ]');
            // console.log('invitation: ', invitation);

            Vue.set(this.form, 'email', invitation.email)

            axios.delete(`/settings/invitations/${invitation.id}`)
                .then(() => {
                    Spark.post(`/settings/${Spark.pluralTeamString}/${invitation.team_id}/invitations`, this.form)
                        .then(() => {
                            this.form.email = '';

                            this.$parent.$emit('updateInvitations');

                            let button = document.querySelector('#resend_invitation_button')
                            if (button) button.setAttribute('disabled', true)
                            if (button) button.textContent = 'Sent'
                        });
                });

        },


    }
});